import React from 'react';

interface WarningTriangleProps {
  size?: number; // Size of the entire component (circle + icon)
  iconColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
}

export const WarningTriangle = ({ 
  size = 40, 
  iconColor = '#111111',
  backgroundColor = '#FC5000',
  strokeWidth = 2
}: WarningTriangleProps) => {
  const innerSize = size - 4; // Leave 2px padding on each side (4px total)
  
  return (
    <div 
      style={{ 
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden',
        padding: 2,
        transform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
        WebkitFontSmoothing: 'antialiased'
      } as React.CSSProperties}
    >
      <svg 
        width={innerSize} 
        height={innerSize} 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{
          display: 'block',
          shapeRendering: 'crispEdges',
          transform: 'translateZ(0)'
        }}
      >
        <path 
          d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z" 
          stroke={iconColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    </div>
  );
};

